import { vehicleDimensionSchema } from './vehicle-dimension.schema';
import { vehicleTypeSchema } from '../../../schemas/vehicle-type.schema';
import { z } from 'zod/v4';

export const vehicleDimensionsThresholdSchema = z.object({
  vehicleDimensionMax: vehicleDimensionSchema,
  vehicleDimensionMin: vehicleDimensionSchema,
  vehicleType: vehicleTypeSchema,
});

export type VehicleDimensionsThreshold = z.infer<
  typeof vehicleDimensionsThresholdSchema
>;
